<mat-tab-group
  *ngIf="isGenericAprCase"
  color="primary"
  class="correspondenceTab"
>
  <mat-tab
    label="Detailed Approval Note"
    class="tabNew"
    *ngIf="!caseDetails.parallelRecordVO"
  >
    <form [formGroup]="expForm">
      <div class="row dg-form-row">
        <div class="col-md-6">
          <mat-form-field class="w-100 mt-3">
            <mat-label class="required-field"
              >{{ "generic_approval.Subject" | translate }}
            </mat-label>
            <textarea
              class="text-area"
              matInput
              formControlName="subject"
              [rows]="2"
              [readonly]="fieldDisabled"
              style="overflow: hidden"
              cdkTextareaAutosize
            ></textarea>
            <mat-error *ngIf="expForm?.controls?.subject?.errors?.maxlength">
              {{
                "generic_approval.Maximum characters allowed is 100" | translate
              }}
            </mat-error>
            <mat-error *ngIf="expForm?.controls?.subject?.errors?.required"
              >Please enter Subject</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="row dg-form-row">
        <div class="col-md-6">
          <mat-form-field class="w-100 mt-2">
            <mat-label class="required-field">{{
              "generic_approval.Background/Justification" | translate
            }}</mat-label>
            <textarea
              class="text-area"
              matInput
              formControlName="background"
              [rows]="2"
              [readonly]="fieldDisabled"
              style="overflow: hidden"
              cdkTextareaAutosize
            ></textarea>
            <mat-error *ngIf="expForm?.controls?.background?.errors?.maxlength">
              {{
                "generic_approval.Maximum characters allowed is 2000"
                  | translate
              }}
            </mat-error>
            <mat-error *ngIf="expForm?.controls?.background?.errors?.required"
              >Please enter Background/Justification</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field class="w-100 mt-2">
            <mat-label class="required-field">
              {{ "generic_approval.Proposed " | translate }}</mat-label
            >
            <textarea
              class="text-area"
              matInput
              formControlName="transaction"
              [rows]="2"
              [readonly]="fieldDisabled"
              style="overflow: hidden"
              cdkTextareaAutosize
            ></textarea>
            <mat-error
              *ngIf="expForm?.controls?.transaction?.errors?.maxlength"
            >
              {{
                "generic_approval.Maximum characters allowed is 2000"
                  | translate
              }}
            </mat-error>
            <mat-error *ngIf="expForm?.controls?.transaction?.errors?.required"
              >Please enter Transaction Proposed</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="row dg-form-row">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label class="required-field">
              {{
                "generic_approval.Budget/Cost involved" | translate
              }}</mat-label
            >

            <textarea
              class="text-area"
              matInput
              formControlName="budget"
              [rows]="2"
              [readOnly]="fieldDisabled"
              style="overflow: hidden"
              cdkTextareaAutosize
            ></textarea>
            <mat-error *ngIf="expForm?.controls?.budget?.errors?.maxlength">
              {{
                "generic_approval.Maximum characters allowed is 500" | translate
              }}
            </mat-error>
            <mat-error *ngIf="expForm?.controls?.budget?.errors?.required">
              Please enter Budget/Cost involved
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <mat-label class="required-field">
              {{ "generic_approval.Annexures" | translate }}
            </mat-label>
            <textarea
              class="text-area"
              matInput
              formControlName="nature"
              [rows]="2"
              [readonly]="fieldDisabled"
              style="overflow: hidden"
              cdkTextareaAutosize
            ></textarea>

            <mat-error *ngIf="expForm?.controls?.nature?.errors?.maxlength">
              {{
                "generic_approval.Maximum characters allowed is 500" | translate
              }}
            </mat-error>
            <mat-error *ngIf="expForm?.controls?.nature?.errors?.required"
              >Please enter Nature of Document</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="mt-2 mb-2">
        <dg-file-upload
          *ngIf="refreshUpload"
          [refreshAttachComponent]="isRefresh"
          class="file-upload"
          [multiple]="true"
          [title]="'Supporting Documents'"
          [previousPath]=""
          (finalPath)="onFinalPath($event)"
          [edit]="true"
          [isPreview]="true"
          [docTypeCode]="'CASES'"
          [allowMerging]="false"
          [allowDelete]="true"
          [attachSmall]="true"
          [allowFileToAttach]="
            this.initiatorFlag &&
            !fieldDisabled &&
            !this.approvedFlag &&
            !(isFromOutboxCases || readOnly)
          "
          [attachId]="this.expForm?.controls?.attachFile?.value"
        >
        </dg-file-upload>
      </div>
      <ng-container *ngTemplateOutlet="isUpdateBtn"></ng-container>
      <ng-container *ngTemplateOutlet="isReturnToHierarchy"></ng-container>
    </form>
  </mat-tab>
  <mat-tab label="Hierarchy">
    <ng-template matStepLabel> Approver selection </ng-template>
    <ng-container *ngTemplateOutlet="updateHierarchyTmplt"></ng-container>
    <ng-container *ngTemplateOutlet="isUpdateBtn"></ng-container>
    <button
      color="primary"
      mat-raised-button
      class="actions-button ms-2 mb-2"
      *ngIf="this.approvedFlag && !isFromOutboxCases"
      (click)="getviewData()"
    >
      Approval Note
    </button>
  </mat-tab>
</mat-tab-group>
<div *ngIf="!isGenericAprCase">
  <p mat-dialog-title class="dg-h-15 dg-txt-primary">Update Hierarchy</p>
  <div mat-dialog-content>
    <ng-container *ngTemplateOutlet="updateHierarchyTmplt"></ng-container>
  </div>
  <div mat-dialog-action-buttons class="align-end">
    <ng-container *ngTemplateOutlet="isUpdateBtn"></ng-container>
    <button mat-raised-button class="actions-button ms-2 mb-2" mat-dialog-close>
      {{ "generic_approval.Close" | translate }}
    </button>
  </div>
</div>

<ng-template #isUpdateBtn>
  <button
    color="primary"
    *ngIf="
      this.initiatorFlag &&
      !fieldDisabled &&
      !this.approvedFlag &&
      !(isFromOutboxCases || readOnly)
    "
    mat-raised-button
    class="actions-button ms-2 mb-2"
    [disabled]="(updatedisable && updateDisable()) || isFromOutboxCases"
    (click)="onSave()"
  >
    {{ "generic_approval.Update" | translate }}
  </button>
</ng-template>
<ng-template #isReturnToHierarchy>
  <button
    color="primary"
    *ngIf="this.returnToHierarchyFlag && !(isFromOutboxCases || readOnly)"
    mat-raised-button
    class="actions-button ms-2 mb-2"
    (click)="onReturnToHierarchy()"
  >
    {{ "generic_info.returnBtn" | translate }}
  </button>
</ng-template>
<ng-template #updateHierarchyTmplt>
  <div *ngIf="!fieldDisabled && this.updateHierarchyFlag">
    <button
      color="primary"
      *ngIf="
        this.caseDetails.fileStageId != '133' &&
        !(isFromOutboxCases || readOnly)
      "
      mat-raised-button
      class="actions-button mb-2"
      (click)="openEmpDialog()"
      [disabled]="isFromOutboxCases"
    >
      {{ "generic_approval.Hierarchy selection" | translate }}
    </button>
  </div>
  <dg-employee-search
    #empSearch
    [empConfig]="empConfig"
    [orgConfig]="orgConfig"
    (output)="getData2($event)"
    hidden
  >
  </dg-employee-search>

  <dynamic-grid
    [rows]="accessRows"
    [cols]="accessCols"
    [pageSize]="pageSize"
    [addRowAtTop]="addRowAtTop"
    [showSearch]="false"
    [colPropConfig]="colPropConfig"
    [canAddRow]="false"
    [pinColumn]="undefined"
  >
  </dynamic-grid>
</ng-template>
<ng-template #returnToTemplate>
  <h2 mat-dialog-title>{{ "generic_info.Return" | translate }}</h2>
  <mat-dialog-content>
    <h3>{{ "generic_info.returnMessage" | translate }}</h3>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-flat-button mat-dialog-close>No</button>
    <button
      mat-button
      mat-raised-button
      cdkFocusInitial
      color="primary"
      (click)="onReturn()"
    >
      Yes
    </button>
  </mat-dialog-actions>
</ng-template>
